import type { Tool } from "@/app/tools/types";

// Extract the name without the version (e.g. Github.CountStargazers@1.0.0 -> Github.CountStargazers)
export const extractToolName = (tool: Tool) => {
  const fullName = tool.fully_qualified_name;
  const lastAtIndex = fullName.lastIndexOf("@");
  return lastAtIndex === -1 ? fullName : fullName.substring(0, lastAtIndex);
};
